export default {
  dataIterator: {
    rowsPerPageText: 'عناصر في الصفحة:',
    rowsPerPageAll: 'الكل',
    pageText: '{0}-{1} من {2}',
    noResultsText: 'لم يتم العثور على سجلات مطابقة',
    nextPage: 'الصفحة التالية',
    prevPage: 'الصفحة السابقة'
  },
  dataTable: {
    rowsPerPageText: 'صفوف في الصفحة:'
  },
  noDataText: 'لا توجد بيانات متاحة',
  carousel: {
    prev: 'السابق',
    next: 'التالي'
  },
  errors: {
    codeIncorrect: 'الرمز غير صحيح.',
    errorLogin: 'خطأ في تسجيل الدخول',
    qr: {
      notAllowed: 'خطأ: تحتاج إلى منح إذن الوصول إلى الكاميرا',
      notFound: 'خطأ: لا توجد كاميرا على هذا الجهاز',
      notSupported: 'خطأ: يتطلب سياقًا آمنًا (HTTPS، localhost)',
      notReadable: 'خطأ: هل الكاميرا قيد الاستخدام بالفعل؟',
      overConstrained: 'خطأ: الكاميرات المثبتة غير مناسبة',
      streamAPINotSupported: 'خطأ: Stream API غير مدعوم في هذا المتصفح',
      scanFailed: 'رمز QR غير صالح',
      tableNumberFailed: 'رقم الطاولة غير صالح'
    },
    location: {
      inStoreTitle: 'موقعك الحالي ليس في المتجر',
      inStoreDescription: 'لا يمكنك تقديم طلب للجلوس في المتجر، يرجى اختيار الاستلام أو التوصيل',
      inStoreBtn: 'قبول',
      locationDisabledTitle: 'الرجاء السماح بموقع GPS',
      locationDescription: 'يرجى مسح رمز QR مرة أخرى، والسماح بموقع GPS، أو تمكينه مباشرة من إعدادات هاتفك',
      locationBtn: 'قبول'
    },
    cart: {
      menuUnavailable: 'القائمة غير متاحة خلال هذه الساعات',
      startShopping: 'ابدأ الطلب'
    },
    schedule: {
      availableTimes: 'يتوفر {0} فقط من {1} إلى {2}',
      unavailableTimes: 'يتوفر {0} من {1} إلى {2}',
      availableDay: 'سيكون {0} متاحًا في {1} في {2}',
      unavailable: 'يتوفر {0} حاليًا. جرب نوع طلب آخر',
      startScheduling: 'يمكنك البدء في جدولة الطلبات في {0} في {1}'
    },
    paymentUnsuccessful: 'الدفع غير ناجح',
    temporarilyAppear: 'قد تظهر هذه الرسوم مؤقتًا في كشف حسابك قبل إزالتها',
    pageNotFound: 'الصفحة غير موجودة',
    storeNotFoundMessage: 'لم يتم العثور على المتجر الذي تبحث عنه. قد يكون تم نقله، حذفه، أو قد يكون الرابط غير صحيح.'
  },
  common: {
    storeHoursClosedHoliday: 'مغلق',
    today: 'اليوم',
    nextAvailable: 'متاح في المرة القادمة',
    referralButtonText: 'ادعُ أصدقاءك',
    pointsEarned: 'النقاط المكتسبة',
    confirmTitle: 'الرجاء التأكيد',
    confirmDesc: 'هل أنت متأكد أنك تريد التبديل من الطلب في المتجر؟',
    actionText: 'نعم، قم بالتبديل',
    pickup: 'استلام',
    delivery: 'توصيل',
    availableToDeliver: 'متاح للتوصيل',
    notAvailableForDelivery: 'غير متاح للتوصيل',
    loginDescription: 'سجل أو قم بتسجيل الدخول الآن لفتح كوبونات حصرية ومكافآت وعروض مخصصة لك فقط!',
    orderNow: 'اطلب الآن',
    hours: 'ساعات العمل',
    location: 'الموقع',
    contact: 'اتصل بنا',
    socials: 'وسائل التواصل الاجتماعي',
    snappyWhy: 'لماذا Snappy',
    snappyBlog: 'المدونة',
    snappyPricing: 'الأسعار',
    snappyDemo: 'احجز عرضًا توضيحيًا',
    snappyCaseStudies: 'دراسات الحالة',
    clickToRedeem: 'انقر للاسترداد',
    apply: 'تطبيق',
    order: 'الطلب',
    sortByDistance: 'الترتيب حسب المسافة',
    sortByAlpha: 'الترتيب أبجديًا',
    searchLocations: 'البحث عن المواقع',
    az: 'أ-ي',
    nearest: 'الأقرب',
    atLeast: 'على الأقل',
    to: 'إلى',
    takeout: 'للخارج',
    or: 'أو',
    guest: 'ضيف',
    back: 'رجوع',
    other: 'أخرى',
    groups: 'مجموعات',
    options: 'خيارات',
    edit: 'تعديل',
    register: 'تسجيل',
    poweredBy: 'مدعوم من',
    firstName: 'الاسم الأول',
    lastName: 'الاسم الأخير',
    phone: 'الهاتف',
    phoneNumber: 'رقم الهاتف',
    address: 'العنوان',
    storeHours: 'ساعات العمل',
    onlineOrderAvailableUntil: 'الطلب الإلكتروني متاح حتى',
    mobileNumber: 'رقم الهاتف المحمول',
    status: 'الحالة',
    points: 'النقاط',
    balance: 'الرصيد',
    save: 'حفظ',
    changesSaved: 'تم حفظ التغييرات',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    message: 'رسالة',
    loadMore: 'تحميل المزيد',
    loading: 'جاري التحميل...',
    expires: 'ينتهي في',
    login: 'تسجيل الدخول / التسجيل',
    tweet: 'تغريد',
    share: 'مشاركة',
    resend: '(أرسل مرة أخرى في: {0})',
    newCode: 'رمز جديد',
    logout: 'تسجيل الخروج',
    fillFields: 'الرجاء تعبئة جميع الحقول المطلوبة',
    invalidEmail: 'البريد الإلكتروني غير صالح',
    verify: 'رمز مكون من 6 أرقام',
    continue: 'متابعة',
    verifyCode: 'تحقق من الرمز',
    sixDigitCode: 'رمز من 6 أرقام',
    unlimited: 'غير محدود',
    upTo: 'حتى',
    selected: 'محدد',
    items: 'عناصر',
    amount: 'المبلغ',
    scanQRCode: 'امسح رمز QR للجلوس في المتجر',
    loadingQRScanner: 'جاري تحميل الماسح الضوئي...',
    reloadQRScanner: 'إعادة تحميل',
    open: 'مفتوح',
    open2: 'مفتوح',
    closed: 'مغلق',
    closed2: 'مغلق',
    email: 'البريد الإلكتروني',
    select: 'اختار',
    ok: 'موافق',
    okConfirm: 'موافق',
    off: 'خصم',
    app: {
      text1: 'افتح في',
      text2: 'التطبيق',
      btn: 'افتح'
    },
    captcha: {
      main: 'هذا الموقع محمي بواسطة reCAPTCHA و',
      privacy: 'سياسة الخصوصية',
      and: 'و',
      terms: 'شروط الخدمة',
      apply: 'تطبق.'
    },
    disclaimer: {
      main: 'من خلال تسجيل الدخول، أوافق على <link-tos>شروط الخدمة</link-tos> و<link-pp>سياسة الخصوصية</link-pp>. أوافق على تلقي رسائل SMS وغيرها من الاتصالات الرقمية، بما في ذلك القسائم والعروض الخاصة والعروض الترويجية من {businessName}. قد يتم تطبيق رسوم الرسائل والبيانات القياسية.',
      register: 'بالنقر على تسجيل، فإنك توافق على <link-tos>شروط الخدمة</link-tos> و <link-pp>سياسة الخصوصية</link-pp> الخاصة بـ Snappy. ستستخدم Snappy معلومات الرسائل النصية لتأمين حسابك وإرسال الإشعارات. يمكنك إلغاء الاشتراك في الرسائل النصية في أي وقت.'
    },
    addedToCart: 'تمت إضافة "{0}" إلى السلة',
    yourOrderId: 'رقم طلبك هو'
  },
  hours: {
    twentyFourHours: 'مفتوح 24 ساعة',
    midNight: 'منتصف الليل',
    mon: 'الاثنين',
    tues: 'الثلاثاء',
    wed: 'الأربعاء',
    thurs: 'الخميس',
    fri: 'الجمعة',
    sat: 'السبت',
    sun: 'الأحد',
    monday: 'الاثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
    sunday: 'الأحد'
  },
  menu: {
    specialRequests: 'تعليمات خاصة',
    required: 'مطلوب',
    optional: 'اختياري',
    soldOut: 'نفدت الكمية',
    selectMenu: 'الرجاء اختيار قائمة',
    menuTitle: 'القائمة',
    promotionsAndRewards: 'العروض والمكافآت',
    categories: 'الفئات',
    noMenu: 'لم يتم العثور على قائمة في المتجر',
    dropdown: 'قائمة منسدلة',
    unavailable: 'القائمة غير متاحة',
    available: 'ساعات التوفر',
    dayAvailable: 'متاح في المرة القادمة',
    availableOffHours: 'هذه القائمة متاحة للطلبات المجدولة',
    menuIsExclusive: 'لا يمكن إضافة العناصر من قوائم مختلفة إلى نفس السلة',
    item: {
      onlyAvailable: 'متاح',
      available: 'هذا العنصر متاح فقط من {0} إلى {1}',
      prepTime: 'عادة ما يستغرق هذا العنصر حوالي {0} للتحضير'
    },
    menuAvailability: 'توفر القائمة',
    gotIt: 'فهمت!',
    onlyAvailable: 'هذه القائمة متاحة فقط خلال ساعات محددة:',
    pricingBanner: 'اطلب مباشرة من {2} ووفر ما يصل إلى {0}% في المتوسط مقارنةً بـ {1}'
  },
  cart: {
    title: 'سلة التسوق',
    startShopping: 'ابدأ الطلب',
    continue: 'متابعة',
    serviceFee: 'رسوم الخدمة',
    takeOutOrder: 'طلب للتحضير للخارج',
    backToLogin: 'العودة إلى تسجيل الدخول',
    enterYourAddress: 'عنوان التوصيل',
    startAdding: 'ابدأ بإضافة العناصر من القائمة لبناء طلبك.',
    buildOrder: 'أضف عناصر جديدة لمواصلة بناء طلبك',
    currentlyClosed: ' مغلق حاليًا. يرجى العودة خلال ساعات العمل المناسبة.',
    delivery: 'توصيل',
    pickup: 'استلام',
    dinein: 'الجلوس في المتجر',
    estTimeHours: 'ساعات',
    estTimeMins: 'دقيقة',
    subtotal: 'المجموع الفرعي',
    deliveryFee: 'رسوم التوصيل',
    tbd: 'سيتم تحديده',
    deliveryMinimum: 'الحد الأدنى للتوصيل',
    pickupMinimum: 'الحد الأدنى للاستلام',
    tax: 'الضريبة',
    tip: 'إكرامية',
    tipDriver: 'إكرامية للسائق',
    tipStore: 'دعم المتجر بإكرامية',
    rewards: 'مكافآت',
    total: 'المجموع',
    btnCheckout: 'الدفع',
    addToCart: 'أضف إلى السلة',
    aiRecommendationsTitle: 'موصى به لك',
    aiRecommendationsTitleGuest: 'موصى به',
    aiRecommendationsSubtitle: 'بناءً على طلباتك',
    aiRecommendationsSubtitleGuest: 'الأكثر شيوعاً في هذا المتجر',
    aiRecommendationsFrom: 'من',
    saveCartItem: 'تحديث السلة',
    clickToSee: 'انقر لرؤية الخيارات',
    payWithMembership: 'الدفع بالعضوية',
    btnSubmitSubOrder: 'إرسال الطلب',
    processing: 'جاري معالجة طلبك',
    pastOrders: 'الطلبات السابقة',
    discount: 'خصم',
    btnPayOrder: 'إرسال الطلب',
    closeModal: 'إغلاق',
    cartUnavailable: 'هناك عناصر في سلتك لا يمكن طلبها بسبب تعارض أو عدم توفر',
    storeUnavailable: 'غير متاح حاليًا',
    storeClosedBtn: 'المتجر مغلق',
    offHourOrderingMaybeAllowed: 'المتجر مغلق حاليًا. ومع ذلك، لا يزال بإمكانك جدولة طلب لوقت لاحق.',
    advanceBookingWindow: 'المتجر مفتوح لكنه لا يقبل الطلبات بعد. يمكنك جدولة طلب لوقت لاحق.',
    deliveryUnavailable: 'التوصيل غير متاح حاليًا',
    pickupUnavailable: 'الاستلام غير متاح حاليًا',
    tooSmallForDelivery: 'مبلغ الطلب صغير جدًا للتوصيل (الحد الأدنى: {0})',
    tooSmallForPickup: 'مبلغ الطلب صغير جدًا للاستلام (الحد الأدنى: {0})',
    invalidCoupon: 'كوبون غير صالح',
    cartErrors: 'أخطاء في السلة',
    removeInvalidItemToContinue: 'يرجى إزالته للمتابعة.',
    discountNotUsed: 'يجب ألا تكون السلة فارغة',
    deliveryDisabled: 'تم تعطيل التوصيل مؤقتًا من قبل التاجر',
    pickupDisabled: 'تم تعطيل الاستلام مؤقتًا من قبل التاجر',
    deliveryDisabledUntil: 'تم تعطيل التوصيل مؤقتًا<br>من قبل التاجر حتى {0}',
    pickupDisabledUntil: 'تم تعطيل الاستلام مؤقتًا<br>من قبل التاجر حتى {0}',
    asapClosed: 'مغلق · يفتح {0} في {1}',
    asapPastCutoff: 'لم يعد يقبل الطلبات لهذا اليوم',
    asapSuspendedToday: 'لم يعد يقبل الطلبات لهذا اليوم',
    storeStoppedAcceptingOrders: 'توقف المتجر عن قبول الطلبات أثناء إتمام الطلب. اختر وقتًا مجدولاً للمتابعة.'
  },
  account: {
    accountInfo: 'معلومات الحساب',
    orderHistory: 'سجل الطلبات',
    paymentMethods: 'طرق الدفع',
    contactInfo: 'معلومات الاتصال',
    membershipInfo: 'معلومات العضوية',
    member: 'عضو',
    nonMember: 'غير عضو',
    creditCard: 'بطاقة الائتمان',
    nameOnCard: 'الاسم على البطاقة',
    cardNumber: 'رقم البطاقة',
    expires: 'ينتهي في',
    cvc: 'CVC',
    mmyy: 'شهر / سنة',
    country: 'بلد الفوترة',
    saveCard: 'حفظ البطاقة',
    addPaymentMethod: 'إضافة طريقة دفع',
    deliveryDetails: 'تفاصيل التوصيل',
    noOrderHistory: 'لا يوجد سجل طلبات',
    noPaymentMethods: 'لا توجد طرق دفع',
    addPaymentMethodPrompt: 'يرجى إضافة طريقة دفع',
    noCreditCards: 'لا توجد طرق دفع',
    otherPostalCode: 'بالنسبة للبطاقات من خارج الولايات المتحدة أو كندا، يرجى إدخال أي رقم',
    membership: 'العضوية',
    history: 'السجل',
    payments: 'المدفوعات',
    offline: 'الدفع شخصيًا',
    orderId: 'رقم الطلب',
    editTitle: 'تعديل المعلومات الشخصية',
    payment: {
      title: 'حذف طريقة الدفع',
      body: 'هل أنت متأكد أنك تريد حذف طريقة الدفع هذه؟',
      cancel: 'إلغاء',
      delete: 'حذف',
      status: {
        cvcFailed: 'CVC غير صالح',
        postalCodeFailed: 'الرمز البريدي غير صحيح',
        expiredCard: 'البطاقة منتهية الصلاحية'
      }
    },
    rewards: {
      redeemFor: 'استبدال بـ',
      rewardOptions: 'خيارات المكافآت',
      coupons: 'كوبونات',
      punchCards: 'بطاقات النقاط',
      using: 'قيد الاستخدام',
      remaining: 'متبقي',
      free: 'مجاني',
      purchases: 'المشتريات',
      redeem: 'استرداد',
      max: 'الحد الأقصى',
      points: 'نقاط',
      credits: 'أرصدة',
      discount: 'خصم',
      yourPoints: 'نقاطك',
      creditsEarned: 'تم كسب {0}',
      worth: 'بقيمة',
      insufficientFunds: 'الأموال غير كافية',
      removeFirst: 'يرجى إزالة خيار المكافأة النشط أولاً',
      punchCardRibbon: 'اشترِ {0} إضافيًا من {1} مقابل {2}!',
      selectItem: 'اختر العنصر',
      availableInCart: 'تظهر المكافآت المتاحة في السلة',
      availableInCartUpdated: 'انقر على سلتك لاسترداد هذه المكافأة!',
      alreadyInCart: 'تمت إضافة "{0}" بالفعل إلى سلتك',
      missingPoints: 'تحتاج إلى {0} نقطة إضافية لاستخدام بطاقة النقاط هذه!',
      inEligible: 'أنت غير مؤهل لهذا الكوبون',
      noExpiration: 'بدون انتهاء',
      noLimitation: 'بدون قيود',
      buy1Get1Free: 'اشترِ 1 واحصل على 1 مجاناً',
      buy1Get1PercentOff: 'اشترِ 1 واحصل على 1 بخصم {0}%',
      buy1Get1AmountOff: 'اشترِ 1 واحصل على 1 بخصم ${0}',
      validForSelectItems: 'صالح لعناصر مختارة',
      discountPercentOff: 'خصم {0}%',
      discountAmountOff: 'خصم {0}{1}',
      discountOff: 'خصم {0}',
      discountUpTo: '{0}، بحد أقصى {1}',
      maxDiscountReached: 'تم الوصول إلى الحد الأقصى للخصم {0}',
      maxDiscountOf: 'حتى {0}',
      maxDiscountOfDetail: 'الحد الأقصى للخصم {0}',
      offerExpires: 'تنتهي العرض: {0}',
      loginPrompt: 'يرجى تسجيل الدخول لرؤية مكافآتك',
      inPersonRedeemable: 'هذه المكافأة قابلة للاسترداد في المتجر فقط',
      orderRewards: {
        congrats: 'تهانينا!',
        coupons: 'لقد حصل طلبك على كوبون إضافي',
        lossFallback: 'عذرًا، لم تفز هذه المرة، يرجى المحاولة مرة أخرى في الطلب القادم!'
      }
    }
  },
  storePage: {
    aiRecommendationsCategory: 'موصى به لك',
    aiRecommendationsCategoryGuest: 'موصى به',
    deliveryProvider: {
      robot: 'روبوت',
      human: 'ساعي',
      byRobot: 'التقِ بالروبوت في الخارج',
      byHuman: 'التقِ بالساعي عند الباب',
      recommended: 'موصى به من قبل هذا النشاط التجاري',
      notSupported: 'توصيل {0} غير مدعوم لعنوانك',
      deliveryInstructions: 'يرجى العلم أن الروبوتات لا يمكنها صعود السلالم. ستحتاج إلى توفير الرمز الذي تم إرساله إلى بريدك الإلكتروني لاستلام طعامك'
    },
    error: {
      empty: 'لا يوجد شيء للعرض هنا!',
      noResults: 'لم يتم العثور على نتائج.',
      tryAdjusting: 'حاول تعديل الفلتر الخاص بك',
      clear: 'مسح البحث'
    }
  },
  order: {
    estimatedTime: 'تم تقديم طلبك بنجاح، سيكون جاهزًا للاستلام في {0}',
    estimatedTimeDiff: 'تم تقديم طلبك بنجاح، سيكون جاهزًا للاستلام في حوالي {0}',
    successfulOrder: 'تم تقديم طلبك بنجاح',
    deliveryAddressInvalid: 'العنوان الذي أدخلته غير صالح، يرجى المحاولة مرة أخرى',
    deliveryAddressMustBeSet: 'يجب تعيين عنوان التوصيل الخاص بك',
    deliveryAddressMustBeInRange: 'عذرًا، عنوانك ليس ضمن نطاق التوصيل، يرجى الاتصال بالمتجر لتقديم طلبك',
    noPaymentMethodSelected: 'يرجى اختيار طريقة دفع',
    insufficientPoints: 'رصيد العضوية غير كافٍ',
    requiresAdditionalMethod: 'الرصيد غير كافٍ، تتطلب طريقة دفع ثانية',
    cardMinimumCharge: 'يجب دفع {0} على الأقل بالبطاقة. أضف إكرامية أو منتجًا آخر، أو ادفع هذا الطلب بالبطاقة.',
    minCardChargeNote: 'الحد الأدنى للدفع بالبطاقة {0}',
    applyMembershipInstead: 'تطبيق {0} بدلاً من ذلك',
    noPaymentMethods: 'يرجى اختيار طريقة دفع',
    pickUpDetails: 'تفاصيل الاستلام',
    orderDetails: 'تفاصيل الطلب',
    selectOrderType: 'اختر نوع الطلب',
    orderPlaced: 'تم تقديم الطلب',
    orderScheduled: 'الوقت المحدد',
    orderNotes: 'ملاحظات الطلب',
    pickUpTime: 'وقت الاستلام',
    pickUpDay: 'يوم الاستلام',
    deliveryTime: 'وقت التوصيل',
    deliveryDay: 'يوم التوصيل',
    deliveryAddress: 'عنوان التوصيل',
    addressLine1: 'السطر الأول من العنوان',
    addressLine2: 'السطر الثاني من العنوان',
    postalCode: 'الرمز البريدي',
    city: 'المدينة',
    payment: 'الدفع',
    placeOrder: 'إرسال الطلب',
    personalDetails: 'تفاصيل شخصية',
    tableNumberSet: 'تم تعيين رقم طاولتك.',
    onlyOffline: 'هذا المتجر يقبل الدفع شخصيًا فقط.',
    paidOffline: 'سيتم دفع الطلب شخصيًا',
    emailReceipt: 'أرسل لي الإيصال عبر البريد الإلكتروني',
    offlineEmailReceipt: 'أرسل لي تأكيد الطلب عبر البريد الإلكتروني',
    status: {
      new: 'جديد',
      inProgress: 'قيد التقدم',
      ready: 'جاهز',
      cancelled: 'ملغى',
      refunded: 'تم استرداد المبلغ',
      completed: 'مكتمل'
    },
    orderActions: {
      call: 'اتصل',
      direction: 'الاتجاهات',
      orders: 'عرض الطلبات',
      feedbackTitle: 'فكر في تقديم ملاحظات حول طلبك',
      feedbackLabel: 'قدم ملاحظات'
    }
  },
  iosBanner: {
    partOne: 'انقر على أيقونة المشاركة',
    partTwo: 'ثم حدد إضافة إلى الشاشة الرئيسية',
    partThree: 'للتثبيت'
  },
  checkoutSuccess: {
    text: 'تم الدفع بنجاح'
  },
  orderSubmitted: {
    text: 'تم إرسال الطلب'
  },
  deliveryDialog: {
    title: 'تفاصيل التوصيل',
    deliverAsap: 'توصيل في أقرب وقت ممكن',
    schedule: 'جدولة',
    update: 'تحديث',
    selectAddress: 'يرجى إدخال عنوانك',
    noDeliveryProviders: 'لا يوجد مقدمو توصيل يدعمون هذا العنوان',
    deliveryAddressSet: 'تم تعيين عنوان التوصيل!',
    selectDateTime: 'يرجى اختيار تاريخ ووقت صالحين',
    notAvailable: 'عذرًا، هذا غير متاح',
    pleaseSelectDate: 'يرجى اختيار تاريخ'
  },
  orderDialog: {
    title: 'تفاصيل الاستلام',
    deliveryTitle: 'تفاصيل التوصيل',
    pickUpAsap: 'استلام في أقرب وقت ممكن',
    deliverAsap: 'توصيل في أقرب وقت ممكن',
    schedule: 'جدولة',
    done: 'تم',
    selectDate: 'يرجى اختيار تاريخ',
    notAvailable: 'عذرًا، هذا غير متاح',
    selectDateTime: 'يرجى اختيار تاريخ ووقت صالحين',
    noAvailableDays: 'عذرًا، لا توجد أيام متاحة',
    earliestDate: 'تم تعيين أقرب تاريخ',
    staleTimeBodyGroup: 'لا يمكن للمتجر تجهيز طلبك بحلول {0}. اختر وقتًا جديدًا للمتابعة — لن تتغير عناصر مجموعتك وضيوفك.',
    staleTimeBodySolo: 'لا يمكن للمتجر تجهيز طلبك بحلول {0}. اختر وقتًا جديدًا للمتابعة.',
    confirmSlot: 'تأكيد {0}',
    goBack: 'رجوع'
  },
  storeLocation: {
    pickUpAt: 'استلام في',
    inStore: 'في المتجر',
    pickUpTime: 'وقت الاستلام',
    deliveryTime: 'وقت التوصيل',
    time: 'الوقت',
    deliverTo: 'التوصيل إلى',
    clickToSet: 'انقر للتعيين'
  },
  orderTypes: {
    pickup: 'استلام',
    delivery: 'توصيل',
    dineIn: 'تناول الطعام في المطعم'
  },
  groupOrder: {
    title: 'طلب جماعي',
    namePlaceholder: 'اسم الطلب الجماعي',
    from: 'من',
    deliverTo: 'التوصيل إلى',
    pickupAt: 'الاستلام من',
    invitePeople: 'دعوة أشخاص',
    chooseWhoPays: 'اختر من يدفع',
    paySubtitle: 'سيتم محاسبة المضيف (أنت) على إجمالي الطلب الجماعي. سيتم إدخال طريقة الدفع عند الدفع.',
    youPayForEveryone: 'أنت تدفع عن الجميع',
    hostWillPayForEveryone: 'المضيف سيدفع عن الجميع',
    limitPlaceholder: 'أدخل الحد لكل شخص (اختياري)',
    perPerson: 'لكل شخص',
    everyonePaysThemselves: 'كل شخص يدفع بنفسه',
    comingSoon: 'قريباً',
    next: 'التالي',
    yourGroupOrderLink: 'رابط طلبك الجماعي',
    copy: 'نسخ',
    share: 'مشاركة',
    linkCopied: 'تم نسخ الرابط!',
    join: 'انضم إلى طلب {0} الجماعي',
    spendingLimit: 'حد الإنفاق',
    limitNoLimit: 'بلا حد',
    limitOther: 'أخرى',
    joinGroupOrder: 'الانضمام إلى الطلب الجماعي',
    joining: 'جارٍ الانضمام...',
    loginToJoin: 'تسجيل الدخول للانضمام',
    continueAsGuest: 'المتابعة كضيف',
    enterYourName: 'أدخل اسمك',
    joinOrderDisclaimer: 'بالنقر على "انضمام للطلب" فأنت توافق على',
    joinOrder: 'انضمام للطلب',
    back: 'رجوع',
    notSet: 'غير محدد',
    cancelGroupOrder: 'إلغاء الطلب الجماعي',
    cancelGroupOrderConfirmTitle: 'هل تريد إلغاء {0}؟',
    cancelGroupOrderConfirmBody: 'سيؤدي هذا إلى إنهاء الطلب الجماعي للجميع وإزالة جميع المشاركين.',
    cancelGroupOrderConfirm: 'نعم، إلغاء',
    cancelGroupOrderKeep: 'الإبقاء على الطلب الجماعي',
    cartMenuCancelGroup: 'إلغاء الطلب الجماعي',
    cartMenuLeaveGroup: 'مغادرة',
    cartMenuInvite: 'دعوة أشخاص',
    lockedBannerGuest: 'تم قفل هذا الطلب الجماعي. يرجى التواصل مع المضيف لإجراء تغييرات.',
    lockedBannerHost: 'تم قفل سلة تسوقك. لا يزال بإمكانك المتابعة إلى الدفع.',
    unlockMyCart: 'فتح قفل سلتي',
    othersInGroup: 'الآخرون في مجموعتك ({0} أشخاص)',
    othersHaveAdded: '{0} من {1} أضافوا عناصر',
    memberHostLabel: '(المضيف)',
    memberReadyBadge: 'جاهز',
    memberWaitingBadge: 'في الانتظار',
    memberErrorBadge: 'عنصر غير متوفر',
    memberCartHasErrors: 'أحد أعضاء مجموعتك لديه عنصر غير متوفر. يرجى إزالته للمتابعة.',
    memberNoItems: 'لا توجد عناصر بعد',
    unlockMemberCart: 'فتح قفل سلة {0}',
    removeMember: 'إزالة {0}',
    yourItems: 'عناصرك',
    leaveConfirmTitle: 'هل تريد مغادرة هذا الطلب الجماعي؟',
    leaveConfirmBody: 'ستتم إزالة عناصرك وسيتم إعلام المضيف بمغادرتك.',
    leaveConfirmBtn: 'مغادرة',
    leaveConfirmKeep: 'إلغاء',
    removeConfirmTitle: 'هل تريد إزالة {0} من الطلب الجماعي؟',
    removeConfirmBody: 'ستتم إزالة عناصر {0} وسيتم إعلامهم بالإزالة.',
    removeConfirmBtn: 'إزالة {0}',
    checkoutConfirmTitle: 'هل الجميع جاهز؟',
    checkoutConfirmBody: 'إذا واصلت، سيتم قفل الطلب الجماعي ولن يتمكن أحد من إجراء أي تغييرات.',
    unreadyConfirmTitleSingle: '{0} ما زال يطلب',
    unreadyConfirmTitleMulti: '{0} ضيوف ما زالوا يطلبون',
    unreadyConfirmBody: 'إتمام الدفع يغلق الطلب لجميع المشاركين.',
    unreadyConfirmWaitingOnPrefix: 'في انتظار ',
    unreadyConfirmWaitingOnSuffix: '.',
    and: 'و',
    andOthers: 'و {0} آخرين',
    checkoutWithCurrentBtn: 'الدفع مع سلاتهم',
    checkoutWithCurrentSubtext: 'يتضمن الطلب كل ما أضافوه حتى الآن',
    removeCartsCheckoutBtn: 'الدفع بدونهم',
    removeCartsCheckoutSubtext: 'ستتم إزالة سلاتهم وعناصرهم من الطلب',
    errorRemoveUnreadyCarts: 'تعذّرت إزالة بعض السلات غير الجاهزة. حاول مرة أخرى.',
    groupCartEmpty: 'أضف عنصرًا واحدًا على الأقل قبل إتمام الدفع.',
    participantWaiting: 'في الانتظار...',
    notReadyCount: '{0} مشارك(ون) لم يكونوا جاهزين بعد',
    goToCheckout: 'الانتقال إلى الدفع',
    lockedInGroupOrder: 'أنت في طلب جماعي — لا يمكن تغيير نوع الطلب والوقت.',
    checkoutProcessing: 'جارٍ المعالجة...',
    checkoutBackBtn: 'الرجوع',
    readyBtn: 'أنت جاهز!',
    readyHint: 'سيقوم المضيف بتقديم الطلب للجميع.',
    readyStatus: 'أنت جاهز!',
    imReadyBtn: 'أنا جاهز!',
    addItemsBtn: 'إضافة عناصر',
    lockedCheckoutBtn: 'الطلب الجماعي مقفل',
    lockedTimeoutBtn: 'الطلب مقفل — انتهى الوقت',
    exceedsLimit: 'يتجاوز حد الطلب الجماعي',
    snackParticipantLeft: 'غادر {0} الطلب الجماعي.',
    errorMarkReady: 'فشل في تمييز السلة كجاهزة. يرجى المحاولة مرة أخرى.',
    errorCartLocked: 'قام المضيف بقفل الطلب. لا يمكنك إجراء تغييرات الآن.',
    errorUnlockCart: 'تعذّر فتح قفل السلة. يرجى المحاولة مرة أخرى.',
    errorLockGroup: 'فشل في قفل الطلب الجماعي. يرجى المحاولة مرة أخرى.',
    errorLeaveGroup: 'فشل في مغادرة الطلب الجماعي. يرجى المحاولة مرة أخرى.',
    errorCancelGroup: 'فشل في إلغاء الطلب الجماعي. يرجى المحاولة مرة أخرى.',
    errorUnlockMember: 'فشل في فتح قفل السلة. يرجى المحاولة مرة أخرى.',
    errorRemoveParticipant: 'فشل في إزالة المشارك. يرجى المحاولة مرة أخرى.',
    dialogRemovedTitle: 'تمت إزالتك',
    dialogRemovedBody: 'قام المضيف بإزالتك من هذا الطلب الجماعي. تم مسح عناصرك.',
    dialogLeftTitle: 'غادرت {0}',
    dialogLeftBody: 'تم مسح عناصرك.',
    dialogCancelledTitle: 'تم إلغاء الطلب الجماعي',
    dialogCancelledBody: 'قام المضيف بإلغاء هذا الطلب الجماعي.',
    dialogPaidTitle: 'تم تقديم الطلب!',
    dialogPaidBody: 'تم تقديم طلبك الجماعي بنجاح.',
    dialogRecoveredTitle: 'لديك طلب جماعي جارٍ',
    dialogRecoveredHost: 'أنت المضيف',
    dialogRecoveredGuest: 'أنت مشارك',
    dialogRecoveredBtn: 'متابعة',
    deadlineTitle: 'تحديد موعد نهائي',
    deadlineSubtitle: 'متى يجب على الجميع الطلب؟',
    deadlineDayLabel: 'الطلب قبل (اليوم)',
    deadlineTimeLabel: 'الطلب قبل (الوقت)',
    noDeadline: 'بدون موعد نهائي',
    noDeadlineSet: 'لم يتم تحديد موعد نهائي',
    deadlineSpecificTime: 'وقت محدد',
    orderDeadline: 'الموعد النهائي للطلب',
    orderBeforeDeadline: 'اطلب قبل {0}',
    peopleCanOrderAnytime: 'يمكن للناس الطلب في أي وقت',
    notAvailableScheduled: 'غير متاح لهذا الوقت المجدول',
    deadlineNotAvailableNow: 'الموعد النهائي غير متاح عند تعيين وقت التسليم على الآن.',
    noAvailableDeadlineTimes: 'لا توجد أوقات متاحة للموعد النهائي. يرجى تحديد وقت تسليم لاحق.',
    noSpendingLimit: 'لا يوجد حد للإنفاق',
    spendingLimitValue: 'حد {0}',
    dialogChangedTitle: 'تم تحديث الطلب من قبل المضيف',
    dialogChangedToDelivery: 'تم التغيير إلى التوصيل',
    dialogChangedToPickup: 'تم التغيير إلى الاستلام',
    dialogChangedTime: 'تم تغيير الوقت من {0} إلى {1}',
    dialogChangedTimeSet: 'تم تحديد وقت الجدولة إلى {0}',
    dialogChangedTimeCleared: 'تمت إزالة وقت الجدولة (في أقرب وقت)',
    timeChangedLabel: 'تم تغيير الوقت',
    timeChangedToLabel: 'تم تغيير الوقت إلى',
    confirmChangeToDelivery: 'التغيير إلى التوصيل؟',
    confirmChangeToPickup: 'التغيير إلى الاستلام؟',
    confirmChangeTypeBody: 'سيؤدي هذا إلى تحديث نوع الطلب للجميع في المجموعة.',
    asap: 'أقرب وقت',
    orderAsap: 'اطلب في أقرب وقت',
    now: 'الآن',
    staleTimeTitle: 'الوقت الذي اخترته لم يعد متاحًا',
    staleTimeNearestSlotLabel: 'أقرب وقت متاح',
    staleTimeChooseAnother: 'اختر وقتًا آخر',
    errorResetSchedule: 'فشل تحديث الوقت. حاول مرة أخرى.',
    errorUpdateSchedule: 'فشل تحديث الوقت. حاول مرة أخرى.',
    errorUpdateScheduleConflict: 'تعذر التحديث في الوقت الحالي. يرجى المراجعة والمحاولة مرة أخرى.',
    discountsAtCheckout: 'الخصومات تُطبَّق عند الدفع',
    deliveryFeeAtCheckout: 'يُحسب عند الدفع',
    feesCalculatedAtCheckout: 'الضرائب والرسوم والخصومات تُحسب عند الدفع',
    exceedsSpendingLimit: 'هذا العنصر سيتجاوز حد الإنفاق الذي حدده المضيف.',
    cartFinalized: 'تم إنهاء طلبك الجماعي. لا يمكنك إضافة المزيد من العناصر.',
    noDeadlineSlots: 'لا توجد فترات زمنية متاحة لتحديد موعد نهائي.',
    errorUpdateDeadline: 'تعذّر تحديث الموعد النهائي. حاول مرة أخرى.',
    deadlineUpdated: 'تم تحديث الموعد النهائي للطلب: {0}',
    deadlineRemoved: 'تم تحديث الموعد النهائي للطلب.',
    shareGroupOrder: 'انضم إلى طلبي الجماعي!',
    memberLocked: 'مقفل',
    snackParticipantLeftHost: 'غادر {0} الطلب الجماعي.',
    tooltipBadgeNew: 'جديد',
    tooltipTitle: 'كيف يعمل الطلب الجماعي',
    tooltipScene1Caption: 'ابدأ طلبًا جماعيًا من صفحة القائمة',
    tooltipScene2Caption: 'حدد موعدًا نهائيًا — ومن سيدفع',
    tooltipScene3Caption: 'شارك الرابط، أو دع الأصدقاء يمسحون الرمز للانضمام',
    tooltipScene4Caption: 'يضيف الجميع إلى سلة واحدة. عملية دفع واحدة.',
    tooltipStartBtn: 'ابدأ طلبًا جماعيًا',
    tooltipGotItBtn: 'حسنًا',
    tooltipDemoPeopleJoined: 'انضم {0} أشخاص',
    tooltipDemoDeadlineTimeExample: 'الجمعة، 10 يوليو · 12:30 م',
    tooltipDemoPaySub: 'أنت تدفع · حد $15 لكل شخص',
    tooltipDemoLinkExample: 'gosnappy.io/g/tonnys-order…',
    tooltipDemoGroupCartLabel: 'سلة المجموعة',
    tooltipDemoOneCheckout: 'عملية دفع واحدة — أنت تدفع',
    sheetTitle: 'الطلب الجماعي هنا الآن',
    sheetSubtitle: 'اطلبوا معًا — سلة واحدة مشتركة، ودفع واحد.',
    sheetBullet1: 'حدد موعدًا نهائيًا للطلب',
    sheetBullet2: 'أنت تدفع — أو حدد حدًا للإنفاق',
    sheetBullet3: 'ادعُ الآخرين برابط أو رمز QR',
    sheetNotNowBtn: 'ليس الآن',
    showHowItWorks: 'أرني كيف يعمل هذا',
    hostSetsTip: 'بصفتك المضيف، أنت من يحدد الإكرامية لطلب المجموعة بأكمله.',
    checkoutErrorGeneric: 'فشل الدفع. يرجى المحاولة مرة أخرى.',
    checkoutErrorInvalidCart: 'بعض العناصر في السلة تحتاج إلى مراجعة قبل إتمام الطلب.',
    checkoutErrorOutOfStock: 'بعض العناصر لم تعد متوفرة. يرجى إزالتها والمحاولة مرة أخرى.',
    checkoutErrorMissingSelection: 'يرجى مراجعة الخيارات المحددة لأحد عناصر السلة.',
    checkoutErrorInvalidItem: 'أحد عناصر السلة لم يعد صالحًا. يرجى إزالته والمحاولة مرة أخرى.',
    checkoutErrorPaymentDeclined: 'تم رفض بطاقتك. يرجى تجربة طريقة دفع أخرى.',
    checkoutErrorPaymentFraud: 'تم رفض طريقة الدفع هذه من قبل جهة إصدار البطاقة. يرجى تجربة طريقة أخرى.',
    checkoutErrorCardDetails: 'هناك مشكلة في بيانات البطاقة. يرجى التحقق والمحاولة مرة أخرى.',
    checkoutErrorCardExpired: 'انتهت صلاحية هذه البطاقة. يرجى تجربة طريقة دفع أخرى.',
    checkoutErrorPaymentGateway: 'تعذر معالجة الدفع. يرجى المحاولة مرة أخرى.',
    checkoutErrorNotOpen: 'طلب المجموعة هذا لم يعد مفتوحًا.',
    checkoutErrorVersionConflict: 'تغير طلب المجموعة أثناء إتمام الدفع. يرجى المراجعة والمحاولة مرة أخرى.',
    checkoutErrorInProgress: 'عملية الدفع قيد التنفيذ بالفعل.',
    checkoutErrorEmpty: 'سلة المجموعة فارغة.',
    checkoutErrorBlocked: 'بعض المشاركين ليسوا جاهزين بعد.',
  },
  weChat: {
    warning: 'يرجى الخروج من الصفحة واستخدام WeChat Scanner لمسح رمز QR',
    title: 'أدخل رقم الطاولة'
  },
  checkout: {
    addCoupon: 'إضافة كوبون',
    couponCode: 'رمز الكوبون',
    title: 'إرسال الطلب',
    description: 'هل أنت مستعد لإرسال طلبك؟',
    confirmCancel: 'لا',
    confirmApprove: 'نعم',
    onlinePay: 'الدفع عبر الإنترنت',
    weChatPay: 'WeChat Pay',
    unitNumber: 'رقم الوحدة (اختياري)',
    primaryMethod: 'الدفع',
    secondaryMethod: 'طريقة دفع ثانية',
    credits: 'محفظة المتجر',
    orderHints: 'على سبيل المثال، أي قيود غذائية',
    deliveryHints: 'على سبيل المثال، قم برن الجرس بعد التوصيل، اتركه بجانب الشرفة، رقم الجرس، إلخ.',
    deliveryOptions: 'خيارات التوصيل',
    deliveryInstructions: 'تعليمات التوصيل',
    orderDisposables: 'أدوات المائدة، شفاطات، إلخ.',
    deliveryDisposables: 'أدوات مائدة يمكن التخلص منها',
    disposablesIncluded: 'لن يتم تضمين هذه العناصر ما لم تطلبها',
    noPaymentMethods: 'لا توجد خيارات دفع متاحة.<br>يرجى التواصل مع {0}',
    billLoadError: 'تعذر تحميل إجمالي طلبك. يرجى المحاولة مرة أخرى.',
    applePayFailed: 'تعذر بدء Apple Pay. يرجى المحاولة مرة أخرى أو اختيار طريقة دفع أخرى.',
    retry: 'أعد المحاولة',
    confirmDialog: {
      total: 'المجموع',
      name: 'اسم المتجر',
      location: 'موقع المتجر',
      deliveryInfo: 'معلومات التوصيل',
      deliveryAddress: 'عنوان التوصيل',
      deliveryPhone: 'رقم هاتف التوصيل',
      scheduled: 'مجدولة لـ',
      pay: 'دفع',
      pickupTitle: 'الاستلام من المتجر؟',
      pickupBody: 'يرجى تأكيد استلام هذا الطلب من المتجر.',
      pickupTime: 'وقت الاستلام:',
      beforeYouArrive: 'قبل وصولك',
      yesPickUp: 'نعم، سأستلم',
      goBack: 'رجوع'
    },
    deliveryMessage: {
      leave_at_door: 'اتركه عند الباب',
      meet_at_door: 'التقِ عند الباب',
      meet_outside: 'التقِ في الخارج'
    },
    couponTypes: {
      title: 'كوبونك يحد من خيارات الدفع الخاصة بك إلى:',
      membership: 'محفظة المتجر',
      online: 'بطاقات الائتمان',
      wechat: 'WeChat',
      offline: 'الدفع شخصيًا'
    }
  },
  qr: {
    manulInput: 'الماسح الضوئي لا يعمل؟ يرجى إدخال رقم طاولتك.',
    selectTable: 'رقم طاولتك',
    select: 'تأكيد'
  },
  apps: {
    giftcard: 'بطاقات الهدايا',
    coupons: 'شراء كوبونات',
    deposit: 'إضافة أموال',
    lineup: 'قائمة الانتظار',
    reservation: 'الحجوزات'
  },
  requestService: {
    openButton: 'طلب خدمة',
    title: 'قدم طلبًا من النادل الخاص بك',
    sent: 'تم إرسال الطلب',
    login: 'يجب أن تكون مسجلاً الدخول لاستخدام هذه الميزة',
    tableNeeded: 'يرجى تعيين رقم طاولتك لاستخدام هذه الميزة'
  },
  sharedCart: {
    bannerLabel: 'طاولة مشتركة · طاولة #{0}',
    live: 'مباشر',
    staleItemWarning: 'تم التحديث من قبل ضيف آخر — راجع قبل الحفظ',
    sentToKitchen: 'أُرسل إلى المطبخ',
    roundSentToKitchen: 'الجولة {0} · أُرسلت إلى المطبخ',
    alreadyOrdered: 'تم الطلب مسبقًا',
    itemCount: '{0} عناصر',
    stillOrdering: 'إضافة الآن',
    sending: 'جارٍ الإرسال...',
    reconnected: 'تم إعادة الاتصال بالطاولة المشتركة {0}.',
    joinedTitle: 'لقد انضممت إلى الطاولة!',
    joinedBody: 'أنت الآن تشارك طلب هذه الطاولة مع الجميع هنا.',
    completedTitle: 'تم دفع طلب الطاولة!',
    completedBody: 'تم إكمال الدفع لهذه الطاولة. شكراً لك!',
    billAtPosTitle: 'تم إرسال الفاتورة إلى الصندوق',
    billAtPosBody: 'تم إرسال فاتورة طاولتك إلى الصندوق. يرجى الدفع هناك لإكمال طلبك.',
    cancelledTitle: 'انتهت جلسة الطاولة',
    cancelledBody: 'انتهت صلاحية جلسة سلة التسوق المشتركة لهذه الطاولة. يرجى مسح رمز QR لبدء جلسة جديدة.',
    roundFired: 'تم إرسال العناصر إلى المطبخ.',
    errorFireRound: 'فشل الإرسال إلى المطبخ. يرجى المحاولة مرة أخرى.',
    errorItemChanged: 'قام شخص آخر بالفعل بتغيير هذا العنصر — تم التحديث لأحدث نسخة، يرجى المحاولة مرة أخرى.',
    errorMutateCart: 'لم تتم العملية. يرجى المحاولة مرة أخرى.',
    errorSessionClosed: 'تم إغلاق هذه الطاولة بالفعل.',
    sharedTable: 'طاولة مشتركة',
    sharedTableActive: '● الطاولة المشتركة نشطة',
    tableLabel: 'طاولة {0}',
    errorStartSharedTable: 'تعذر بدء الطاولة المشتركة. يرجى المحاولة مرة أخرى.',
  },
}